import React from "react";
// import PerformanceManagementbanner from "../../AVHRBanner/Performance_Management_Banner.png";
import performanceoneimg from "../../Images/PerformanceManagementoneimg.png";
import performancetwoimg from "../../Images/PerformanceManagementTwoimg.png";
import performancethreeimg from "../../Images/PerformanceManagementthreeimg.png";
import performancefourimg from "../../Images/PerformanceManagementfourimg.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import PerformanceManagementbanner from "../../AVHRBanner/PerformanceManagementB2.png";

function PerformanceManagement() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        
        <div
  className="relative w-full banner-H banner-Performace"
  
>
  <img
    src={PerformanceManagementbanner}
    className="absolute inset-0 w-full h-full object-cover"
  />
</div>


        <div className="flex justify-content-center px-2 py-4">
          <div className="grid justify-content-center w-full ">
            <div className="col-12 md:col-6 lg:col-4 p-3">
              <div
                className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect"
                // style={{ backgroundColor: " #cb6ce6" }}
              >
                <img
                  src={performanceoneimg}
                  alt="Card 1"
                  className="w-full border-round-lg mb-3"
                  style={{ boxShadow: "2px 2px 7px 1px #cb6ce6" }}
                />
                <h3 className="mb-2 avhrProject-h3">
                  Objective Setting and Key Performance Indicators (KPIs)
                </h3>
                <p className="avhrProject-p">
                  Setting clear objectives and measurable KPIs helps align
                  employee performance with organizational goals. It ensures
                  focused efforts and tracks progress effectively
                </p>
              </div>
            </div>

            <div className="col-12 md:col-6 lg:col-4 p-3">
              <div
                className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect"
                // style={{ backgroundColor: "#8c52ff" }}
              >
                <img
                  src={performancetwoimg}
                  alt="Card 2"
                  className="w-full border-round-lg mb-3"
                  style={{ boxShadow: "2px 2px 7px 1px #8c52ff" }}
                />
                <h3 className="mb-2 avhrProject-h3">Performance Appraisal</h3>
                <p className="avhrProject-p">
                  Performance appraisals provide structured feedback on employee
                  contributions and areas for improvement. They support career
                  growth and informed decision-making
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-content-center px-2 py-4">
          <div className="grid justify-content-center w-full ">
            <div className="col-12 md:col-6 lg:col-4 p-3">
              <div
                className="p-2 shadow-2 text-center border-round-lg h-full  card-hover-effect"
                
              >
                <img
                  src={performancethreeimg}
                  alt="Card 3"
                  className="w-full border-round-lg mb-3"
                  style={{ boxShadow: "2px 2px 7px 1px #ff914d" }}
                />
                <h3 className="mb-2 avhrProject-h3">
                  Performance Analytics and Data-Driven Insights
                </h3>
                <p className="avhrProject-p">
                  Data-driven insights help identify performance trends and gaps
                  across teams. Analytics enables better, evidence-based talent
                  management decisions
                </p>
              </div>
            </div>

            <div className="col-12 md:col-6 lg:col-4 p-3">
              <div
                className="p-2 shadow-2 text-center border-round-lg h-full card-hover-effect"
                // style={{ backgroundColor: "#fff7ad" }}
              >
                <img
                  src={performancefourimg}
                  alt="Card 4"
                  className="w-full border-round-lg mb-3"
                  style={{ boxShadow: "2px 2px 7px 1px #fff7ad" }}
                />
                <h3 className="mb-2 avhrProject-h3">
                  Performance Improvement Plans (PIPs)
                </h3>
                <p className="avhrProject-p">
                  PIPs offer underperforming employees a chance to improve
                  through clear goals and support. They promote accountability
                  and structured performance recovery
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background:
                "linear-gradient(45deg, #FF9BA5, #FFE187, #FBC78A, #E88AA0, #C98AB1)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2 ">
              Growth powered by feedback, goals, and appreciation
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default PerformanceManagement;
